import { Container } from "react-bootstrap";

const BeatsHelp = () => {
  return (
    <Container>
      <h1>Beats Help</h1>
      <p>
        If you need help with Beats, please contact us at{" "}
        <a href="mailto:support@beatbind.io">support@beatbind.io</a>.
      </p>
    </Container>
  );
}

export default BeatsHelp;
